import { toast } from "react-toastify";
import { postLoginInstance } from "../../utils";
import { API_LIMIT, MAX_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllRoleData } from "./SubloginAction";




export const getAllRoleApi = (ctx = null) => {
    ctx?.setState?.({ isLoading: true })
    return function (dispatch, getState) {
        const params = new URLSearchParams(ctx?.props?.location?.search);
        const searchValue = params.get("search") || "";
        const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
        const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;
        const page = parseInt(params.get("page"), 10) || START_PAGE;

        return postLoginInstance.get(`childRole?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${page}${searchValue && `&searchValue=${searchValue}`}`)
            .then((res) => {

                // return ctx.setState({ dummyData: res.data.data ,});
                dispatch(getAllRoleData(res.data.data, ctx?.state.currentPage || START_PAGE));
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Something went wrong")
            }).finally(() => {
                ctx?.setState?.({ isLoading: false })
            })
    }

};

export const fetchModuleFeatures = async (ctx) => {

    try {
        ctx?.setState?.({ isLoading: true })
        const features = await postLoginInstance.get("/moduleFeature") || [];
        const baseFeatures = features?.data?.data?.list?.map(m => m.features).flat() || [];
        const dataFeatures = ctx?.state?.editData?.childRoleFeatures?.map(m => m.features?.map(f => ({
            ...f.feature,
            isEnabled: f.isEnabled,
            useParent: f.useParent,
            config: f.config || "{}"
        }))).flat() || []
        const childRoleFeatures = baseFeatures.map(feature => {
            const matched = dataFeatures.find(f => f.id === feature.id) || {}
            return {
                ...feature,
                isEnabled: matched.isEnabled || false,
                useParent: matched.useParent || false,
                config: matched.config || "{}",
                featureId: feature.id
            }
        })
        ctx?.setState?.({ childRoleFeatures: childRoleFeatures, isLoading: false })
        return features?.data?.data;
    }
    catch (error) {
        console.error(error?.response?.data?.message || "Something went wrong")
        return null;
    }

}
